import type { ReactNode } from 'react'
import React, { memo, useEffect, useState } from 'react'
import { type Dayjs, dayjs } from '../dayjs.ts'

export const Countdown = memo(
	({
		endTime,
		onTimeout,
		render,
	}: {
		endTime: string | Dayjs
		onTimeout?: () => void
		render?: ({
			days,
			hours,
			minutes,
			seconds,
			isExpired,
		}: {
			days: string
			hours: string
			minutes: string
			seconds: string
			isExpired: boolean
		}) => ReactNode
	}) => {
		const [time, setTime] = useState(dayjs())

		useEffect(() => {
			const interval = setInterval(() => setTime(dayjs()), 1000)
			return () => clearInterval(interval)
		}, [])

		const diff = dayjs.duration(dayjs(endTime).diff(time))
		const isExpired = diff.asMilliseconds() < 0

		const days = isExpired ? '00' : diff.format('D')
		const hours = isExpired ? '00' : diff.format('HH')
		const minutes = isExpired ? '00' : diff.format('mm')
		const seconds = isExpired ? '00' : diff.format('ss')

		useEffect(() => {
			if (isExpired && onTimeout) {
				onTimeout()
			}
		}, [isExpired, onTimeout])

		if (render) {
			return <>{render({ days, hours, minutes, seconds, isExpired })}</>
		}

		return (
			<React.Fragment>
				{minutes}:{seconds}
			</React.Fragment>
		)
	},
)
